import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useParams } from "react-router-dom";
import { useAppState } from "../context/AppContext";
import { auth } from "../services/firebase";
import { signInWithCustomToken } from "firebase/auth";

function SignInWithToken() {
  const { token } = useParams();
  const { state } = useAppState();
  const [errorMessage, setErrorMessage] = useState(null);
  const navigate = useNavigate();

  // Sign in with custom token on load
  useEffect(() => {
    const signIn = async () => {
      try {
        await signInWithCustomToken(auth, token);
      } catch (error) {
        setErrorMessage(error.message || "Sign in failed");
      }
    };
    signIn();
  }, [token]);

  // After auth, redirect if user and practices exist
  useEffect(() => {
    if (!state.authChecked || !state.user) return;
    if (!state.user?.practices || !state.user?.practices?.length) {
      return alert(
        "No practices associated with this account, please reach out to support@evviaftercare.com"
      );
    }
    navigate(`/${state.user.practices[0].slug}`);
  }, [state, navigate]);

  if (errorMessage) {
    return (
      <div className="container">
        <div>Sign In With Token Error: {errorMessage}</div>
      </div>
    );
  } else {
    return <div className="loading-screen regular-2xl">Loading...</div>;
  }
}

export default SignInWithToken;
